import { Component, OnInit,  ChangeDetectionStrategy,OnChanges,SimpleChanges,Input,AfterViewInit } from '@angular/core';
import Chart from 'chart.js';
@Component({
  selector: 'sb-chart-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.css']
})
export class BarChartComponent implements OnInit,OnChanges,AfterViewInit {
  @Input() dataChart: {data: any[]; labelsHorizontal: string[];};
  @Input() chartInputId:any;
  chart!: Chart;
  chartId: string="1";
  constructor() { }
  
  ngOnInit(): void {
    this.chartId=this.chartInputId;  
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataChart.currentValue) {
      if (this.chart){
        this.chart.destroy();
        this.chart = null;
      }
      this.createChart();
    }
  } 

  ngAfterViewInit() {
    this.createChart();
  }
  createChart(){    
    this.chart = new Chart(this.chartId, {
      type: 'bar', 
      data: {
        labels: this.dataChart?.labelsHorizontal,
        datasets:  this.dataChart?.data,
      },
      options: {
        aspectRatio:2.5,
        legend: { 
          display: true 
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              min: 0,
            }
          }]
        },
      },
    });
  }
}

